import React from 'react';
import styled from 'styled-components';

export type MessageMode = 'compose' | 'history';

interface ModeTabsProps {
  activeMode: MessageMode;
  onModeChange: (mode: MessageMode) => void;
  hideCompose?: boolean;
}

const TabsContainer = styled.div`
  display: flex;
  margin: ${({ theme }) => theme.spacing.ms};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background};
`;

const Tab = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.ms} ${({ theme }) => theme.spacing.md};
  border: none;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;

  ${({ $active, theme }) =>
    $active
      ? `
    background-color: ${theme.colors.primary};
    color: white;
  `
      : `
    background-color: white;
    color: ${theme.colors.primary};
  `}
`;

export const ModeTabs: React.FC<ModeTabsProps> = ({ activeMode, onModeChange, hideCompose = false }) => {
  return (
    <TabsContainer>
      <Tab $active={activeMode === 'history'} onClick={() => onModeChange('history')}>
        やりとり
      </Tab>
      {!hideCompose && (
        <Tab $active={activeMode === 'compose'} onClick={() => onModeChange('compose')}>
          新しく連絡する
        </Tab>
      )}
    </TabsContainer>
  );
};

export default ModeTabs;
